export default function AnalyticsIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 20.0635V13.0635M12 20.0635V10.0635M4 20.0635L4 16.0635M13.4067 5.09104L18.5751 7.02921M10.7988 5.46446L5.20023 9.66337M21.0607 6.50288C21.6464 7.08866 21.6464 8.03841 21.0607 8.6242C20.4749 9.20998 19.5251 9.20998 18.9393 8.6242C18.3536 8.03841 18.3536 7.08866 18.9393 6.50288C19.5251 5.91709 20.4749 5.91709 21.0607 6.50288ZM5.06066 9.50288C5.64645 10.0887 5.64645 11.0384 5.06066 11.6242C4.47487 12.21 3.52513 12.21 2.93934 11.6242C2.35355 11.0384 2.35355 10.0887 2.93934 9.50288C3.52513 8.91709 4.47487 8.91709 5.06066 9.50288ZM13.0607 3.50288C13.6464 4.08866 13.6464 5.03841 13.0607 5.6242C12.4749 6.20998 11.5251 6.20998 10.9393 5.6242C10.3536 5.03841 10.3536 4.08866 10.9393 3.50288C11.5251 2.91709 12.4749 2.91709 13.0607 3.50288Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
